import { pageIdInfos } from '@/Providers'

export const StepCounterPagePaths = new Set<string>([
  pageIdInfos.step_counter.url,
  pageIdInfos.step_counter_terms_withdrawal.url,
])
